<app-modal-filler-atom
  (click)="close()"
  index="5"
></app-modal-filler-atom>
<div
  class="fixed mx-auto right-0 left-0 shadow overflow-y-auto bottom-0 max-h-85-screen max-w-screen-sm lg:flex lg:justify-center lg:items-center lg:w-full lg:h-full lg:top-0 lg:left-0'"
  [style.z-index]="750"
>
  <div class="p-5 md:p-7 pt-10 bg-white rounded-t-3xl lg:rounded-3xl">
    <app-block-list
      [blockIdList]="content"
      [injectData]="getData()"
    ></app-block-list>
  </div>
</div>
